<div class="img-bg mt-sm"
     (click)="openGallery()"
     style="height: 120px;width: 100%;border-radius: var(--app-border-radius)"
     [appBackgroundImage]="this.image?.content">
    <div class="img-overlay light d-flex flex-column ion-justify-content-center ion-align-items-center app-border-radius">
        <ion-button class="outline"
                    *ngIf="!image?.content">
            <span class="material-symbols-outlined pr-sm">upload</span>
            CARICA
        </ion-button>
    </div>
</div>
